import { Component } from '@angular/core'
import { Store } from '@ngrx/store'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { TemplateService } from '@tokeet-frontend/templates'
import { NotifyAutomationBaseComponent } from '../notify-automatotion.component'
import { Actions } from '@ngrx/effects'
import { ConfirmDialogService } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-notify-handler-automation',
  templateUrl: './notify-handler-automation.component.html',
  styleUrls: ['./notify-handler-automation.component.scss'],
})
export class NotifyHandlerAutomationComponent extends NotifyAutomationBaseComponent {
  constructor(
    protected actions: Actions,
    protected store: Store<any>,
    protected amplitudeService: AmplitudeService,
    protected templateService: TemplateService,
    protected confirm: ConfirmDialogService
  ) {
    super(actions, store, amplitudeService, templateService, confirm)
  }

  getAutopilotId() {
    return `autopilot-notify-handler|${this.service}|${this.type}|${this.event}|${this.handler}|${this.idSuffix || ''}`
  }
}
